import { DefaultCarPageComponentProps } from "@/app/interface/components";
import CustomLink from "@/app/components/CustomLink";

interface NavBarMobileProps extends DefaultCarPageComponentProps {
  show: boolean;
}

function NavBarMobile({
  car,
  model,
  version,
  color,
  setModel,
  setVersion,
  setColor,
  show,
}: NavBarMobileProps) {
  return (
    <header
      className={`flex w-full bg-black px-4 py-4 items-center justify-between sticky z-20 transition-all duration-500 ease-in-out ${
        show ? "top-[90px]" : "top-[50px]"
      }`}
    >
      <h1 className="text-white">{car?.name}</h1>
      <CustomLink
        href="#proposta"
        className="animate-pulse-red bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-6 rounded-xl min-h-[40px] transition-colors duration-300"
      >
        Solicitar Atendimento
      </CustomLink>
    </header>
  );
}

export default NavBarMobile;
